import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"
import { RecentActivityQueryParams, RecentActivityResponse } from "@custom-types/recentActivity"

export const recentActivityApi = createApi({
  reducerPath: "recentActivityApi",
  baseQuery: authQuery,
  tagTypes: ["RecentActivity"],
  endpoints: (builder) => ({
    getRecentActivity: builder.query<RecentActivityResponse, RecentActivityQueryParams>({
      query: ({
        pagination__last__key,
        pagination__limit,
        pagination__last__creation_date,
        pagination__last__creator_email,
        pagination__last__tag,
        tag,
        user_key,
      }) => ({
        url: "/recent_activity",
        params: {
          tag: tag || undefined,
          user_key: user_key || undefined,
          pagination__last__key: pagination__last__key || undefined,
          pagination__limit: pagination__limit || undefined,
          pagination__last__creation_date: pagination__last__creation_date || undefined,
          pagination__last__creator_email: pagination__last__creator_email || undefined,
          pagination__last__tag: pagination__last__tag || undefined,
        },
      }),
      providesTags: ["RecentActivity"],
    }),
  }),
})

export const { useGetRecentActivityQuery } = recentActivityApi
